import { Checkbox, FormControlLabel, Grid, Typography } from '@mui/material'
import { useAppDispatch, useAppSelector } from 'app/hooks'
import { UIAction } from 'app/slices/UI'
import EventCard from 'components/EventCard'
import MultipleSelectCheckMarks from 'components/MultipleSelectCheckMarks'
import { format } from 'date-fns'
import { Prefecture } from 'interface'
import { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'

export default function Event() {
  const [searchParams] = useSearchParams()
  const organizerId = searchParams.get('organizer')
  const UIPrefectures = useAppSelector((s) => s.UI.prefectures)
  const events = useAppSelector((s) => s.Event.list)
  const [prefectures, setPrefectures] = useState<Prefecture[]>([])
  const [showAllEvent, setShowAllEvent] = useState(
    Boolean(Number(localStorage.getItem('showAllEvent')))
  )
  const dispatch = useAppDispatch()
  useEffect(() => {
    dispatch(
      UIAction.setBreadcrumbs([
        {
          text: 'ホーム',
          url: '/',
        },
        {
          text: 'イベント一覧',
          url: '/event',
        },
      ])
    )
  }, [dispatch])
  return (
    <Grid container spacing={1} mt={2}>
      <Grid item xs={12}>
        <Typography
          variant="h5"
          component="h2"
          sx={{ borderBottom: 2 }}
          fontWeight="bold"
        >
          イベント管理
        </Typography>
      </Grid>
      <Grid item xs={12} ml={1}>
        <Typography variant="h6" component="h3" fontWeight="bold">
          イベント検索
        </Typography>
        <MultipleSelectCheckMarks
          label="開催地域を絞り込む"
          options={UIPrefectures}
          handleSelect={(val) => setPrefectures(val)}
        />
        <Typography variant="h6" component="h3" fontWeight="bold">
          イベント一覧
        </Typography>
        <FormControlLabel
          control={
            <Checkbox
              checked={showAllEvent}
              onChange={(event) => {
                const checked = event.target.checked
                localStorage.setItem('showAllEvent', Number(checked).toString())
                setShowAllEvent(checked)
              }}
            />
          }
          label="終了したイベントを表示する"
        />
        <Grid container spacing={2} mt={2}>
          {events
            .filter(
              (f) =>
                (showAllEvent || f.endDate > new Date().getTime()) &&
                (prefectures.length === 0 ||
                  prefectures.map((v) => v.id).includes(f.prefectureId)) &&
                (!organizerId || f.organizerId === organizerId)
            )
            .reverse()
            .map((v) => {
              return (
                <Grid item xs={12} md={6} key={v.id}>
                  <EventCard
                    to={'/event/' + v.id}
                    title={v.name}
                    place={v.address}
                    time={`${format(v.startDate, 'yyyy/MM/dd')} ～ ${format(
                      v.endDate,
                      'yyyy/MM/dd'
                    )}`}
                    summary={v.summary}
                    src={`${v.image}`}
                  />
                </Grid>
              )
            })}
        </Grid>
      </Grid>
    </Grid>
  )
}
